"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealVkusvillVomlLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealVkusvillVomlLinear = function MealVkusvillVomlLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.698 32a.835.835 0 00.695-.395c.353-.532.86-.945 1.452-1.183a11.617 11.617 0 004.42-2.794M25.698 32v-.808 0V31h-.103m.103 1l-.016-.836h0v-.03L25.679 31a.163.163 0 00-.135.077l.007-.012.008-.012.036-.053m.103 1H14.302m11.293-1a4.157 4.157 0 011.877-1.506l.02-.009.023-.007a10.617 10.617 0 004.01-2.525M25.595 31h-11.19m17.12-4.047l-.027.032.767.643m-.74-.675l.029-.029.71.704m-.74-.675A19.299 19.299 0 0035.954 16m-3.688 11.628A20.3 20.3 0 0036.955 16h-1.002m0 0c.024-.332.04-.666.047-1H4c.008.334.024.668.049 1m31.904 0H4.049m0 0H3.046a20.378 20.378 0 004.69 11.628M4.048 16a19.378 19.378 0 004.427 10.954m0 0l-.029-.029-.712.703m.741-.674l.027.032-.768.642m.741-.674a10.554 10.554 0 004.008 2.523l.023.008.021.009c.761.306 1.414.83 1.877 1.506m-6.67-3.372a11.554 11.554 0 004.42 2.794 3.157 3.157 0 011.452 1.183.82.82 0 00.695.395m.103-1h-.103v1m.103-1l.036.053.01.016.01.017a.178.178 0 00-.15-.086l-.002.14v.04l-.007.82",
    stroke: "#95A0B3",
    strokeWidth: 2
  }));
};

exports.MealVkusvillVomlLinear = MealVkusvillVomlLinear;
var _default = MealVkusvillVomlLinear;
exports.default = _default;